import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["statusButton", "domainButton", "row", "group", "empty"];
  static values = {
    status: { type: String, default: "completed" },
    domain: { type: String, default: "all" },
  };

  connect() {
    this.applyFilters();
  }

  filterStatus(event) {
    event.preventDefault();
    this.statusValue = event.currentTarget.dataset.status;
    this.applyFilters();
  }

  filterDomain(event) {
    event.preventDefault();
    this.domainValue = event.currentTarget.dataset.domain;
    if (event.currentTarget.dataset.resetStatus === 'true') {
      this.statusValue = 'all';
    }
    this.applyFilters();
    this.scrollToCompetencies();
  }

  applyFilters() {
    const status = this.statusValue;
    const domain = this.domainValue;
    let visibleCount = 0;

    this.statusButtonTargets.forEach((button) => {
      button.classList.toggle("is-active", button.dataset.status === status);
    });

    this.domainButtonTargets.forEach((button) => {
      button.classList.toggle("is-active", button.dataset.domain === domain);
    });

    this.rowTargets.forEach((row) => {
      const statusMatch = status === "all" || row.dataset.status === status;
      const domainMatch = domain === "all" || row.dataset.domain === domain;
      const visible = statusMatch && domainMatch;
      row.classList.toggle("d-none", !visible);
      if (visible) {
        visibleCount += 1;
      }
    });

    this.groupTargets.forEach((group) => {
      const domainMatch = domain === "all" || group.dataset.domain === domain;
      const hasVisibleRow = group.querySelector(
        "[data-equal-accreditation-competency-filter-target='row']:not(.d-none)"
      );
      group.classList.toggle("d-none", !domainMatch || !hasVisibleRow);
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", visibleCount > 0);
    }
  }

  scrollToCompetencies() {
    const section = document.getElementById("competencies");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
